import { useContext, createContext } from "react";

export const BszFinderContext = createContext(null);

export function useBszFinderContext() {
  const context = useContext(BszFinderContext);

  if (!context) {
    throw new Error(
      "useBszFinderContext must be used inside BszFinderContext.Provider",
    );
  }

  return context;
}
